// import React from "react";

// const YourDreamOne = () => {
//   return (
//     <section className="your-dream-one section-space">
//       <div className="container">
//         <div className="row gutter-y-40">
//           <div className="col-lg-6">
//             <div
//               className="your-dream-one__thumb wow fadeInLeft"
//               data-wow-duration="1500ms"
//               data-wow-delay="500ms"
//             >
//               <div className="your-dream-one__thumb__item">
//                 <img
//                   // src="/images/about/our-driver-1-1.jpg"
//                   src="/images/about.png"
//                   alt="Sanavi Travels professional driver"
//                 />
//               </div>

//               <div className="your-dream-one__thumb__item-small">
//                 <img
//                   src="/images/about/our-driver-1-2.jpg"
//                   alt="Sanavi Travels well-maintained vehicle"
//                 />
//               </div>

//               <div className="your-dream-one__element-four">
//                 <img
//                   src="/images/shapes/truse-1-1.png"
//                   alt=""
//                 />
//               </div>
//             </div>
//           </div>

//           <div className="col-lg-6">
//             <div className="your-dream-one__container">
//               <div className="sec-title sec-title--two text-start">
//                 <h6 className="sec-title__tagline bw-split-in-right">
//                   TRAVEL WITH CONFIDENCE
//                 </h6>
//                 <h3 className="sec-title__title bw-split-in-left">
//                   TRUSTED TRAVEL PARTNER – SANAVI TRAVELS
//                 </h3>
//               </div>

//               {/* <p
//                 className="your-dream-one__text wow fadeInUp"
//                 data-wow-duration="1500ms"
//                 data-wow-delay="500ms"
//               >
//                 Sanavi Travels is committed to delivering safe, reliable, and
//                 comfortable travel experiences. Whether you are planning a
//                 family trip, corporate travel, airport transfer, or an outstation
//                 journey, our professional drivers and well-maintained vehicles
//                 ensure a smooth and stress-free ride every time.
//               </p> */}

//               <div className="your-dream-one__funfact">
//                 <div className="row gutter-y-30">
//                   {[
//                     {
//                       bg: "funfact-bg-1-1.jpg",
//                       count: "150",
//                       suffix: "+",
//                       text: "Vehicles Available",
//                     },
//                     {
//                       bg: "funfact-bg-1-2.jpg",
//                       count: "10",
//                       suffix: "L+",
//                       text: "Kilometers Covered",
//                     },
//                     {
//                       bg: "funfact-bg-1-3.jpg",
//                       count: "25",
//                       suffix: "K+",
//                       text: "Happy Customers",
//                     },
//                     {
//                       bg: "funfact-bg-1-4.jpg",
//                       count: "12",
//                       suffix: "+",
//                       text: "Years of Experience",
//                     },
//                   ].map((item, index) => (
//                     <div
//                       className="col-md-6 col-sm-12 wow fadeInUp"
//                       data-wow-duration="1500ms"
//                       data-wow-delay="500ms"
//                       key={index}
//                     >
//                       <div className="funfact-one__item count-box">
//                         <div
//                           className="funfact-one__item__bg"
//                           style={{
//                             backgroundImage: `url(/images/resources/${item.bg})`,
//                           }}
//                         ></div>

//                         <h3 className="funfact-one__funfact__count">
//                           <span
//                             className="count-text"
//                             data-stop={item.count}
//                             data-speed="1500"
//                           ></span>
//                           {item.suffix && <span>{item.suffix}</span>}
//                         </h3>

//                         <p className="funfact-one__funfact__text">
//                           {item.text}
//                         </p>

//                         <div className="funfact-one__border__group">
//                           <span></span>
//                           <span></span>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="your-dream-one__element-one">
//         <img
//           src="/images/shapes/truse-1-3.png"
//           alt=""
//         />
//       </div>

//       <div className="your-dream-one__element-two">
//         <img
//           src="/images/shapes/truse-1-1.png"
//           alt=""
//         />
//       </div>

//       <div className="your-dream-one__element-three">
//         <img
//           src="/images/shapes/truse-1-2.png"
//           alt=""
//         />
//       </div>
//     </section>
//   );
// };

// export default YourDreamOne;






import React from "react";
import CountUp from "react-countup";

const YourDreamOne = () => {
  return (
    <section className="your-dream-one section-space">
      <div className="container">
        <div className="row gutter-y-40">
          {/* LEFT IMAGE SECTION */}
          <div className="col-lg-6">
            <div
              className="your-dream-one__thumb wow fadeInLeft"
              data-wow-duration="1500ms"
              data-wow-delay="500ms"
            >
              <div className="your-dream-one__thumb__item">
                <img
                  src="/images/about.png"
                  alt="Sanavi Travels professional driver"
                />
              </div>

              <div className="your-dream-one__thumb__item-small">
                <img
                  src="/images/about/our-driver-1-2.jpg"
                  alt="Sanavi Travels well-maintained vehicle"
                />
              </div>

              <div className="your-dream-one__element-four">
                <img
                  src="/images/shapes/truse-1-1.png"
                  alt=""
                />
              </div>
            </div>
          </div>

          {/* RIGHT CONTENT SECTION */}
          <div className="col-lg-6">
            <div className="your-dream-one__container">
              <div className="sec-title sec-title--two text-start">
                <h6 className="sec-title__tagline bw-split-in-right">
                  TRAVEL WITH CONFIDENCE
                </h6>
                <h3 className="sec-title__title bw-split-in-left">
                  TRUSTED TRAVEL PARTNER – SANAVI TRAVELS
                </h3>
              </div>

              {/* FUN FACTS / COUNTERS */}
              <div className="your-dream-one__funfact">
                <div className="row gutter-y-30">
                  {[
                    {
                      bg: "funfact-bg-1-1.jpg",
                      count: 150,
                      suffix: "+",
                      text: "Vehicles Available",
                    },
                    {
                      bg: "funfact-bg-1-2.jpg",
                      count: 10,
                      suffix: "L+",
                      text: "Kilometers Covered",
                    },
                    {
                      bg: "funfact-bg-1-3.jpg",
                      count: 25,
                      suffix: "K+",
                      text: "Happy Customers",
                    },
                    {
                      bg: "funfact-bg-1-4.jpg",
                      count: 12,
                      suffix: "+",
                      text: "Years of Experience",
                    },
                  ].map((item, index) => (
                    <div
                      className="col-md-6 col-sm-12 wow fadeInUp"
                      data-wow-duration="1500ms"
                      data-wow-delay="500ms"
                      key={index}
                    >
                      <div className="funfact-one__item count-box">
                        <div
                          className="funfact-one__item__bg"
                          style={{
                            backgroundImage: `url(/images/resources/${item.bg})`,
                          }}
                        ></div>

                        <h3 className="funfact-one__funfact__count">
                          <CountUp
                            end={item.count}
                            duration={2}
                            enableScrollSpy
                          />
                          {item.suffix && <span>{item.suffix}</span>}
                        </h3>

                        <p className="funfact-one__funfact__text">
                          {item.text}
                        </p>

                        <div className="funfact-one__border__group">
                          <span></span>
                          <span></span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* DECORATIVE ELEMENTS */}
      <div className="your-dream-one__element-one">
        <img src="/images/shapes/truse-1-3.png" alt="" />
      </div>

      <div className="your-dream-one__element-two">
        <img src="/images/shapes/truse-1-1.png" alt="" />
      </div>

      <div className="your-dream-one__element-three">
        <img src="/images/shapes/truse-1-2.png" alt="" />
      </div>
    </section>
  );
};

export default YourDreamOne;
